import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/main.css';
import { defineCustomElements } from 'ionicons/dist/loader';
defineCustomElements(window);
createApp(App).use(router).mount('#app');

